import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import '@/utils/init';
import { HashRouter } from 'react-router-dom';
import { setPrefix } from '@/utils/logger/arms-config';
import { scaleWindow } from '@/utils/scaleWindow';
import store from '@/stores';
import App from './App';
import '@/styles/tailwind.css';
import { RouterListener } from './RouterListender';

scaleWindow();

setPrefix('Simulate__');

const Comp = () => {
  return (
    <React.Suspense>
      <Provider store={store}>
        <HashRouter>
          <RouterListener>
            <App />
          </RouterListener>
        </HashRouter>
      </Provider>
    </React.Suspense>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(<Comp />);